import Vue from 'vue';
import Router from 'vue-router';
import KeyMap from '../lib/KeyMap';
import config from '../config/index';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('@/components/Home'),
      meta: {
        keepAlive: false,
        title: '诊禾',
      },
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (window.location.href.indexOf('access-token=') > -1) {
    const accessToken = window.location.href.replace(/.*access-token=([^&]*).*/, '$1');
    localStorage.setItem(`token${config.apiAppId}`, accessToken);
  }
  if (Object.keys(KeyMap.ClientKeyMap).length === 0) {
    KeyMap.getKeyMap().then(() => {
      next();
    });
  } else {
    next();
  }
  document.title = to.meta.title;
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js